module.exports = __webpack_public_path__ + "static/media/photo_017.00820a15.JPG";